import { RootState } from '../../store/rootReducer';

export const OtherBrandsAvailableModalContentSelector = (state: RootState) => state.content.otherBrandsAvailableModal;
